var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-loader.ts
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { ChemistryLiteElement } from "../../chemistry-lite-element.js";
import "./x-flex.js";
var XLoader = class extends ChemistryLiteElement {
  styles() {
    return [
      {
        "@keyframes rotate": { "0%": { transform: "rotate(0)" }, "100%": { transform: "rotate(360deg)" } },
        display: "block",
        flexShrink: "0",
        height: "70px",
        width: "70px",
        borderRadius: "50%",
        border: `3px solid ${this.colors.neutral.shade(100)}`,
        borderTopColor: this.colors.accent,
        animation: "rotate 1.1s cubic-bezier(0.3, 0.1, 0.3, 0.85) infinite"
      }
    ];
  }
};
XLoader = __decorateClass([
  customElement("x-loader")
], XLoader);
var LOADER = html` <x-flex w100 h100 center crossaxis-center> <x-loader></x-loader> </x-flex> `;
export {
  LOADER,
  XLoader
};
